module.exports = "'data:image/svg+xml;utf8,<svg width=\"8\" height=\"8\" viewBox=\"0 0 8 8\" xmlns=\"http://www.w3.org/2000/svg\"><title>Slice 1</title><rect stroke=\"%23B6BAC4\" stroke-width=\"2\" x=\"1\" y=\"1\" width=\"6\" height=\"6\" rx=\"40\" fill=\"none\" fill-rule=\"evenodd\"/></svg>'"


//////////////////
// WEBPACK FOOTER
// ./src/Components/ArrayItem/bullet.svg
// module id = 213
// module chunks = 0